export const leaveTypesArray = [
  {
    label: "Sick Leave",
    value: "Sick Leave"
  },
  {
    label: "Casual Leave",
    value: "Casual Leave"
  },
  {
    label: "Maternity Leave",
    value: "Maternity Leave"
  },
  {
    label: "Paternity Leave",
    value: "Paternity Leave"
  },
  {
    label: "Annual Leave",
    value: "Annual Leave"
  },
  {
    label: "Other",
    value: "Other"
  }
];
